import React, { Component, useEffect, useState } from "react"
import { BiCategoryAlt, BiChevronLeft, BiChevronRight } from "react-icons/bi";
import * as rsuite from 'rsuite'
import styled from "styled-components"
import * as General from '../Business/General/General.js'
import * as BiIcon from "react-icons/bi"
import { useNavigate } from 'react-router-dom'
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';


// import InputMask from "react-input-mask";




const LogOut = (props) => {
    const navigate = useNavigate();
    const toaster = rsuite.useToaster();
    // const [open, setopen] = React.useState(false);
    // const [InterMobileNo, setInterMobileNo] = React.useState(true);
    // const [InterActiveCode, setInterActiveCode] = React.useState(false);
    // const [Mobile, setMobile] = React.useState("");
    // const [ActiveCode, setActiveCode] = React.useState("");
    // const [UserDate, setUserDate] = React.useState("");
    // const [Min, setMin] = React.useState(0);
    // const [Sec, setSec] = React.useState(0);
    // let MyInterval = null;
    // var distance = 120000;
    // const formatNumber = {
    //     '#': "[0-9]",

    // };


    const LogOut = () => {
        localStorage.removeItem("UserFullNameFarmAsan")
        localStorage.removeItem("CustomerFarmAsanId")
        localStorage.removeItem("IsSupplierFarmAsanId")
        // setopen(false);
        // setUserDate("");
        window.location.reload();


    }



    return (
        <>

            {localStorage.getItem("UserFullNameFarmAsan") == null || localStorage.getItem("UserFullNameFarmAsan") == "" ? "" :
                <BiIcon.BiLogOutCircle onClick={() => LogOut()} className="fw-bold Font25  Cursor m-2" />
            }


        </>

    )

}

export default LogOut;



